<template>
    <div>
        <div class="ticker-wrapper-h sticky-top-nav">
            <div class="heading">Der 1. Trading-Service mit</div>

            <ul class="news-ticker-h">
                <li><a href=""> • Null-Verlust-Garantie</a></li>
                <li><a href=""> • Geld-zurück-Garantie</a></li>
                <li><a href=""> • Startkapital gesponsert</a></li>
                <li><a href=""> - - - alle wichtigen Infos dazu per
                    Mail anfordern</a></li>
            </ul>
        </div>
        <header style="margin-top:40px;padding-top: 0 !important;">
            <div class="uk-section uk-padding-remove-vertical">
                <nav class="uk-navbar-container" data-uk-sticky="show-on-up: true; animation: uk-animation-slide-top;">
                    <div class="mr-xl-5 ml-xl-5" data-uk-navbar>
                        <div class="uk-navbar-left">
                            <div class="uk-navbar-item">
                                <RouterLink class="text-center mr-lg-5 text-decoration-none"
                                            :to="{ name: 'landing-page' }">
                                    <h3 class="col-12 text-primary-color mb-1 mt-2">
                                        <img style="height: 80px; width: 250px"
                                             src="../../../assets/images/logo/logo2.png" class="pt-1 mt-1 img-fluid"
                                             alt="">
                                    </h3>
                                </RouterLink>
                                <ul class="uk-navbar-nav uk-visible@m">
                                    <li>
                                        <RouterLink :to="{ name: 'webinar-free' }">{{
                                                $t('navbar.webinar')
                                            }}
                                        </RouterLink>
                                    </li>
                                    <li>
                                        <RouterLink :to="{ name: 'e-book' }">{{ $t('navbar.e-book') }}</RouterLink>
                                    </li>
                                    <li>
                                        <RouterLink :to="{ name: 'trading-strategy' }">{{
                                                $t('navbar.trading')
                                            }}
                                        </RouterLink>
                                    </li>
                                    <!--                                <li>-->
                                    <!--                                    <RouterLink :to="{ name: 'blog-page' }">{{ $t('navbar.blog') }}</RouterLink>-->
                                    <!--                                </li>-->
                                    <!--                                <li><a href="#">{{ $t('navbar.company') }}<i class="fas fa-chevron-down"></i></a>-->
                                    <!--                                    <div class="uk-navbar-dropdown">-->
                                    <!--                                        <ul class="uk-nav uk-navbar-dropdown-nav">-->
                                    <!--                                            <li>-->
                                    <!--                                                <RouterLink :to="{ name: 'our-mission-page' }">-->
                                    <!--                                                    {{ $t('navbar.ourMission') }}-->
                                    <!--                                                </RouterLink>-->
                                    <!--                                            </li>-->
                                    <!--                                            <li>-->
                                    <!--                                                <RouterLink :to="{ name: 'agb-page' }">{{-->
                                    <!--                                                        $t('navbar.agb')-->
                                    <!--                                                    }}-->
                                    <!--                                                </RouterLink>-->
                                    <!--                                            </li>-->
                                    <!--                                            <li>-->
                                    <!--                                                <RouterLink :to="{ name: 'impressum' }">Impressum</RouterLink>-->
                                    <!--                                            </li>-->
                                    <!--                                            <li>-->
                                    <!--                                                <RouterLink :to="{ name: 'contact' }">{{-->
                                    <!--                                                        $t('navbar.contact')-->
                                    <!--                                                    }}-->
                                    <!--                                                </RouterLink>-->
                                    <!--                                            </li>-->
                                    <!--                                        </ul>-->
                                    <!--                                    </div>-->
                                    <!--                                </li>-->
                                    <li><a href="#"><img
                                        :src="selectedLang.image" alt="img-flaf" class="img-fluid mr-1"
                                        style="height: 20px; width: 20px;"/><i class="fas fa-chevron-down"></i></a>
                                        <div class="uk-navbar-dropdown">
                                            <ul class="uk-nav uk-navbar-dropdown-nav">
                                                <li v-for="(lang, i) in langsOptions"
                                                    :key="`Lang${i}`">
                                                    <a class="pt-2 langbutton-nav" @click="langChange(lang)">
                                                        <img :src="lang.image" alt="img-flaf"
                                                             class="img-fluid mr-2"/>{{ lang.title }}<br>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="uk-navbar-right">
                            <div v-if="!isAuthed" class="uk-navbar-item uk-visible@m in-optional-nav">
                                <RouterLink :to="{ name: 'pricing-page' }"
                                            class="uk-button uk-button-primary uk-border-rounded primary-background-color text-white">
                                    {{ $t('navbar.onlyOneEuro') }}
                                </RouterLink>
                            </div>
                            <div v-else class="uk-navbar-item uk-visible@m in-optional-nav">
                                <RouterLink :to="{ name:   'dashboard.home-1' }">
                                    <i class="fas fa-sign-in-alt fa-2x primary-color"
                                       style="color: #DAA520!important;"></i>
                                </RouterLink>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    </div>
    <!-- header content end -->
</template>

<script>
import langChange from "../../../Mixins/langchange";
import {mapActions, mapGetters} from "vuex";
import {Auth} from "../../../config/auth";

export default {
    name: "website-navbar",
    mixins: [langChange],
    methods: {
        ...mapActions({
            langChangeState: 'Setting/setLangAction',
        })
    },
    data() {
        return {
            isAuthed: Auth.isAuthed()
        }
    },
    computed: {
        ...mapGetters({
            langsOptions: 'Setting/langOptionState',
            selectedLang: 'Setting/langState'
        })
    }
}
</script>

<style scoped>
/*****************************
*	horizontal news ticker
******************************/

.ticker-wrapper-h {
    display: flex;
    position: relative;
    overflow: hidden;
    border: 2px solid #DAA520;
}

.ticker-wrapper-h .heading {
    background-color: #DAA520;
    color: #fff;
    padding: 5px 10px;
    flex: 0 0 auto;
    z-index: 1000;
}

.ticker-wrapper-h .heading:after {
    content: "";
    position: absolute;
    top: 0;
    border-left: 20px solid #DAA520;
    border-top: 17px solid transparent;
    border-bottom: 15px solid transparent;
}


.news-ticker-h {
    display: flex;
    margin: 0;
    padding: 0;
    padding-left: 90%;
    z-index: 999;

    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: tic-h;
    animation-duration: 30s;

}

.news-ticker-h:hover {
    animation-play-state: paused;
}

.news-ticker-h li {
    display: flex;
    width: 100%;
    align-items: center;
    white-space: nowrap;
    padding-left: 20px;
}

.news-ticker-h li a {
    color: #212529;
    font-weight: bold;
}

.sticky-top-nav {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 5;
    background-color: white;
    color: black;
    text-align: center;
}

@keyframes tic-h {
    0% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
        visibility: visible;
    }
    100% {
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
    }
}
</style>
